"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useTrackPropChanges_1 = require("./useTrackPropChanges");
Object.defineProperty(exports, "useTrackPropChanges", { enumerable: true, get: function () { return useTrackPropChanges_1.default; } });
